module.exports = __webpack_public_path__ + "06_bob_beige.4010cc14.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/06_bob_beige.png
// module id = me+8
// module chunks = 0